var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.25C0.5 2.55381 0.776562 1.88613 1.26884 1.39384C1.76113 0.901562 2.42881 0.625 3.125 0.625H18.875C19.5712 0.625 20.2389 0.901562 20.7312 1.39384C21.2234 1.88613 21.5 2.55381 21.5 3.25V13.75C21.5 14.4462 21.2234 15.1139 20.7312 15.6062C20.2389 16.0984 19.5712 16.375 18.875 16.375H3.125C2.42881 16.375 1.76113 16.0984 1.26884 15.6062C0.776562 15.1139 0.5 14.4462 0.5 13.75V3.25ZM3.125 1.9375C2.7769 1.9375 2.44306 2.07578 2.19692 2.32192C1.95078 2.56806 1.8125 2.9019 1.8125 3.25V4.5625H20.1875V3.25C20.1875 2.9019 20.0492 2.56806 19.8031 2.32192C19.5569 2.07578 19.2231 1.9375 18.875 1.9375H3.125ZM20.1875 7.1875H1.8125V13.75C1.8125 14.0981 1.95078 14.4319 2.19692 14.6781C2.44306 14.9242 2.7769 15.0625 3.125 15.0625H18.875C19.2231 15.0625 19.5569 14.9242 19.8031 14.6781C20.0492 14.4319 20.1875 14.0981 20.1875 13.75V7.1875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTis);
export default __webpack_public_path__ + "static/media/tis.093b4ffdaca320eaaaa2f958756c768f.svg";
export { ForwardRef as ReactComponent };